export var ConnectorMode;
(function (ConnectorMode) {
    ConnectorMode[ConnectorMode["Straight"] = 0] = "Straight";
    ConnectorMode[ConnectorMode["Orthogonal"] = 1] = "Orthogonal";
    ConnectorMode[ConnectorMode["Curve"] = 2] = "Curve";
})(ConnectorMode || (ConnectorMode = {}));
export var ConnectorEndpoint;
(function (ConnectorEndpoint) {
    ConnectorEndpoint["Front"] = "Front";
    ConnectorEndpoint["Rear"] = "Rear";
})(ConnectorEndpoint || (ConnectorEndpoint = {}));
export var ConnectorEndpointStyle;
(function (ConnectorEndpointStyle) {
    ConnectorEndpointStyle["None"] = "None";
    ConnectorEndpointStyle["Arrow"] = "Arrow";
    ConnectorEndpointStyle["Triangle"] = "Triangle";
    ConnectorEndpointStyle["Circle"] = "Circle";
    ConnectorEndpointStyle["Diamond"] = "Diamond";
})(ConnectorEndpointStyle || (ConnectorEndpointStyle = {}));
export const DEFAULT_FRONT_END_POINT_STYLE = ConnectorEndpointStyle.None;
export const DEFAULT_REAR_END_POINT_STYLE = ConnectorEndpointStyle.Arrow;
export const DEFAULT_ARROW_SIZE = 15;
//# sourceMappingURL=types.js.map